(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('BrokerageLocationSearch', BrokerageLocationSearch);

    BrokerageLocationSearch.$inject = ['$resource'];

    function BrokerageLocationSearch($resource) {
        var resourceUrl =  'api/_search/brokerage-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
